// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_box__YQDtG {
    width: 300px;

    /*position: relative;*/
    /*margin: 0 0 auto auto;*/

    display: flex;
    max-height: 100%;
}

.styles_content__dStzx {
    position: relative;

    background: #fbfbfc;
    border-radius: 6px;
    border: 4px double rgba(12, 59, 141, 0.25);
    padding: 40px 0 40px;

    display: flex;
    flex-direction: column;
    /*row-gap: 32px;*/

    margin: 0;
    width: 100%;
    max-height: 100%;
    overflow: auto;
}

.styles_closeBtnWrapper__oA2La {
    position: absolute;
    height: 25px;
    width: 25px;
    right: 14px;
    top: 8px;
}

.styles_closeBtnWrapper__oA2La button {
    height: 25px;
    width: 25px;
    padding: 0;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid var(--primary-color);
    transition: background 0.4s;
    --icon-color-custom: var(--primary-color);
}

.styles_closeBtnWrapper__oA2La button:hover {
    background: var(--primary-color);
    border-color: var(--primary-color);
    --icon-color-custom: #fff;
    /*--icon-fill-color-custom: var(--primary-color-active);*/
}

.styles_closeBtnWrapper__oA2La button * {
    height: 14px;
    width: 14px;
    padding: 0;
    /*display: block;*/
    /*min-height: 25px;*/
    /*min-width: 25px;*/
}

.styles_row__pER2- {
    padding: 6px 20px;
    position: relative;
}

.styles_row__pER2-:first-of-type {
    margin-top: 28px;
}

.styles_row__pER2- > * {
    position: relative;
}

.styles_row__pER2-:before {
    content: '';
    display: block;
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: var(--primary-color);
    transition: opacity 0.4s;
}

.styles_row__pER2-.styles_active__bF-yB:before {
    opacity: 0.1;
}

.styles_rowTitle__y1hDA {
    /*text-transform: uppercase;*/
    font-weight: 500;
    padding-bottom: 8px;
    /*margin-bottom: 12px;*/
    color: var(--dark-grey);
    border-bottom: 0.5px solid var(--dark-grey);
    margin-bottom: 10px;
}

.styles_row__pER2-.styles_active__bF-yB .styles_rowTitle__y1hDA {
    color: var(--primary-color);
}

.styles_rowData__1T6sk {
    display: flex;
    flex-direction: column;
    /*grid-template-columns: repeat(2, calc(100% / 2 - 20px));*/
    grid-gap: 13px;
}

.styles_group__NpDo0 {
    font-weight: 300;
    display: flex;
    flex-direction: column;
    row-gap: 5px;
}

.styles_groupTitle__x7TbU {
    /*margin-bottom: 8px;*/
    font-size: 13px;
    font-weight: 400;
}
.styles_groupTitle__x7TbU:first-letter {
    text-transform: uppercase;
}

.styles_groupValue__xhWhE {
    display: block;
    /*margin-top: 10px;*/
    font-size: 13px;
    /*font-weight: 500;*/
    /*font-weight: 300;*/
    font-weight: 400;
}

.styles_groupValueText__mZ6xA {
    font-size: 12px;
    line-height: 13px;
    /*line-height: 10px;*/
}

.styles_groupValueTextLight__f9eJ\\+ {
    font-weight: 300;
}

.styles_groupRow__9GmmK {
    display: grid;
    grid-template-columns: 1fr 80px;
}

.styles_legend__GjRwL {
    margin-left: 2px;
    font-size: 10px;
    vertical-align: super;
}

.styles_valueBold__E8R6r {
    font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/pages/DealTaxes/components/DealTaxesDetails/styles.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;;IAEZ,sBAAsB;IACtB,yBAAyB;;IAEzB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;;IAElB,mBAAmB;IACnB,kBAAkB;IAClB,0CAA0C;IAC1C,oBAAoB;;IAEpB,aAAa;IACb,sBAAsB;IACtB,iBAAiB;;IAEjB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sCAAsC;IACtC,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,gCAAgC;IAChC,kCAAkC;IAClC,yBAAyB;IACzB,yDAAyD;AAC7D;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,gCAAgC;IAChC,wBAAwB;AAC5B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,2DAA2D;IAC3D,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,oBAAoB;IACpB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".box {\n    width: 300px;\n\n    /*position: relative;*/\n    /*margin: 0 0 auto auto;*/\n\n    display: flex;\n    max-height: 100%;\n}\n\n.content {\n    position: relative;\n\n    background: #fbfbfc;\n    border-radius: 6px;\n    border: 4px double rgba(12, 59, 141, 0.25);\n    padding: 40px 0 40px;\n\n    display: flex;\n    flex-direction: column;\n    /*row-gap: 32px;*/\n\n    margin: 0;\n    width: 100%;\n    max-height: 100%;\n    overflow: auto;\n}\n\n.closeBtnWrapper {\n    position: absolute;\n    height: 25px;\n    width: 25px;\n    right: 14px;\n    top: 8px;\n}\n\n.closeBtnWrapper button {\n    height: 25px;\n    width: 25px;\n    padding: 0;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 1px solid var(--primary-color);\n    transition: background 0.4s;\n    --icon-color-custom: var(--primary-color);\n}\n\n.closeBtnWrapper button:hover {\n    background: var(--primary-color);\n    border-color: var(--primary-color);\n    --icon-color-custom: #fff;\n    /*--icon-fill-color-custom: var(--primary-color-active);*/\n}\n\n.closeBtnWrapper button * {\n    height: 14px;\n    width: 14px;\n    padding: 0;\n    /*display: block;*/\n    /*min-height: 25px;*/\n    /*min-width: 25px;*/\n}\n\n.row {\n    padding: 6px 20px;\n    position: relative;\n}\n\n.row:first-of-type {\n    margin-top: 28px;\n}\n\n.row > * {\n    position: relative;\n}\n\n.row:before {\n    content: '';\n    display: block;\n    opacity: 0;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: var(--primary-color);\n    transition: opacity 0.4s;\n}\n\n.row.active:before {\n    opacity: 0.1;\n}\n\n.rowTitle {\n    /*text-transform: uppercase;*/\n    font-weight: 500;\n    padding-bottom: 8px;\n    /*margin-bottom: 12px;*/\n    color: var(--dark-grey);\n    border-bottom: 0.5px solid var(--dark-grey);\n    margin-bottom: 10px;\n}\n\n.row.active .rowTitle {\n    color: var(--primary-color);\n}\n\n.rowData {\n    display: flex;\n    flex-direction: column;\n    /*grid-template-columns: repeat(2, calc(100% / 2 - 20px));*/\n    grid-gap: 13px;\n}\n\n.group {\n    font-weight: 300;\n    display: flex;\n    flex-direction: column;\n    row-gap: 5px;\n}\n\n.groupTitle {\n    /*margin-bottom: 8px;*/\n    font-size: 13px;\n    font-weight: 400;\n}\n.groupTitle:first-letter {\n    text-transform: uppercase;\n}\n\n.groupValue {\n    display: block;\n    /*margin-top: 10px;*/\n    font-size: 13px;\n    /*font-weight: 500;*/\n    /*font-weight: 300;*/\n    font-weight: 400;\n}\n\n.groupValueText {\n    font-size: 12px;\n    line-height: 13px;\n    /*line-height: 10px;*/\n}\n\n.groupValueTextLight {\n    font-weight: 300;\n}\n\n.groupRow {\n    display: grid;\n    grid-template-columns: 1fr 80px;\n}\n\n.legend {\n    margin-left: 2px;\n    font-size: 10px;\n    vertical-align: super;\n}\n\n.valueBold {\n    font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `styles_box__YQDtG`,
	"content": `styles_content__dStzx`,
	"closeBtnWrapper": `styles_closeBtnWrapper__oA2La`,
	"row": `styles_row__pER2-`,
	"active": `styles_active__bF-yB`,
	"rowTitle": `styles_rowTitle__y1hDA`,
	"rowData": `styles_rowData__1T6sk`,
	"group": `styles_group__NpDo0`,
	"groupTitle": `styles_groupTitle__x7TbU`,
	"groupValue": `styles_groupValue__xhWhE`,
	"groupValueText": `styles_groupValueText__mZ6xA`,
	"groupValueTextLight": `styles_groupValueTextLight__f9eJ+`,
	"groupRow": `styles_groupRow__9GmmK`,
	"legend": `styles_legend__GjRwL`,
	"valueBold": `styles_valueBold__E8R6r`
};
export default ___CSS_LOADER_EXPORT___;
